import {
  Box,
  CircularProgress,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { BlDivider } from "Components/Shared/BlDivider";
import { Trans } from "react-i18next";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  variant?: "loadingInfo" | "processingTransaction";
};

export const LoadingSkeleton = ({ variant = "loadingInfo" }: Props) => {
  const { t } = useResource();
  const resource = Resources.Transactions.Anonymous.LoadingSkeleton[variant];

  return (
    <>
      <Stack alignItems="center" gap={1} mt={2}>
        <Box
          height={50} // To match height of the check icon in SuccessfulTransactionGeneralInfo
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress />
        </Box>
        <Typography variant="h5" fontWeight={600}>
          {t(resource.title)}
        </Typography>
        <Typography lineHeight="28px" textAlign="center">
          <Trans components={{ newline: <br /> }}>
            {t(resource.description)}
          </Trans>
        </Typography>
      </Stack>
      <BlDivider />
      <Stack gap={2}>
        <Skeleton variant="rectangular" height={50} />
        <Skeleton variant="rectangular" height={50} />
        <Skeleton variant="rectangular" height={50} />
      </Stack>
    </>
  );
};
